export const getAllClients = "/clients";
export const createClientUrl = "/client/create/";
export const updateClientUrl = "/client/update";
export const deleteClientUrl = "/client/{clientId}";
export const getClientById = "/client/{clientId}";